import { render, staticRenderFns } from "./FundingPurposes.vue?vue&type=template&id=29630714&scoped=true&"
import script from "./FundingPurposes.vue?vue&type=script&lang=js&"
export * from "./FundingPurposes.vue?vue&type=script&lang=js&"
import style0 from "./FundingPurposes.vue?vue&type=style&index=0&id=29630714&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29630714",
  null
  
)

export default component.exports